<script>
export default {
  name: 'SideMenu',
};
</script>

<template lang="pug">
.app-side-menu
  el-menu.menu(:default-active="$route.path",
    background-color="rgb(234, 238, 241)",
    active-text-color="#189bff"
    text-color="#888"
    router)
    el-menu-item(index="/school/compete/activities")
      i.el-icon-star-on
      span 比赛信息
    el-menu-item(index="/school/compete/entries")
      i.el-icon-star-on
      span 比赛审批
    el-menu-item(index="/school/train/entries")
      i.el-icon-star-on
      span 培训审批
    el-menu-item(index="/school/research/projects")
      i.el-icon-star-on
      span 教改审批
</template>

<style lang="stylus" scoped>
.app-side-menu
  height 100%
  .menu
    height 100%
    background #2C4050
    border-radius 0
    text-align center
    li
      font-size 15px
      font-weight 400
    .is-active
      color #00C187
</style>



// WEBPACK FOOTER //
// SideMenu.vue?84896d4e